
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/congratulation",
      function () {
        return require("private-next-pages/congratulation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/congratulation"])
      });
    }
  